import { render, staticRenderFns } from "./people-profile.vue?vue&type=template&id=3f5519ca&"
import script from "./people-profile.vue?vue&type=script&lang=js&"
export * from "./people-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5519ca')) {
      api.createRecord('3f5519ca', component.options)
    } else {
      api.reload('3f5519ca', component.options)
    }
    module.hot.accept("./people-profile.vue?vue&type=template&id=3f5519ca&", function () {
      api.rerender('3f5519ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/people-profile.vue"
export default component.exports